import React, { Fragment } from "react";
import { navigate } from "gatsby-link";
import {
  ContactPageContainer,
  ContactFormContainer,
  ContactFormTitle,
  ContactFormLabel,
  ContactFormText,
  ContactFormInput,
  ContactFormTextArea,
  ContactFormMapContainer,
} from "./contact-form-styles";
import { CallToActionButton, Map } from "..";

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export const ContactForm = () => {
  const [state, setState] = React.useState({});

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...state,
      }),
    })
      .then(() => navigate(form.getAttribute("action")))
      .catch((error) => alert(error));
  };

  return (
    <Fragment>
      <ContactPageContainer>
        <ContactFormContainer>
          <ContactFormTitle>Contact Form</ContactFormTitle>
          <ContactFormText>
            Use this form to tell us about your project. We encourage you to provide a link to your
            demos.
          </ContactFormText>
          <form
            name="contact"
            method="post"
            action="/thanks/"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <ContactFormInput type="hidden" name="form-name" value="contact" />
            <p hidden>
              <ContactFormLabel>
                Don’t fill this out: <ContactFormInput name="bot-field" onChange={handleChange} />
              </ContactFormLabel>
            </p>
            <p>
              <ContactFormLabel>
                Email *
                <br />
                <ContactFormInput required type="email" name="email" onChange={handleChange} />
              </ContactFormLabel>
            </p>
            <p>
              <ContactFormLabel>
                Artist / Band Name *
                <br />
                <ContactFormInput required type="text" name="name" onChange={handleChange} />
              </ContactFormLabel>
            </p>
            <p>
              <ContactFormLabel>
                Budget *
                <br />
                <ContactFormInput required type="text" name="budget" onChange={handleChange} />
              </ContactFormLabel>
            </p>
            <p>
              <ContactFormLabel>
                Message *
                <br />
                <ContactFormTextArea required name="message" onChange={handleChange} />
              </ContactFormLabel>
            </p>
            <CallToActionButton type="submit">Submit</CallToActionButton>
          </form>
          <ContactFormMapContainer>
            <Map />
          </ContactFormMapContainer>
        </ContactFormContainer>
      </ContactPageContainer>
    </Fragment>
  );
};
